<template>
  <v-container class="py-0">
    <v-row>
      <v-col>
        <div class="display-1 font-weight-normal mb-6 text-center">
          Preencha a informação necessária para a etapa de Obrigações Especiais
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pb-0">
        <validation-provider v-slot="{ errors, valid }" rules="required">
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-calculo-amortizacao', {
                step: 'calculo-amortizacao',
                complete: $event
              })
            "
          />
          <v-select
            v-model="valorTaxaMediaSelecionado"
            :items="itemsValorTaxaMedia"
            :error-messages="errors"
            item-value="id"
            item-text="name"
            placeholder="Selecione a opção para cálculo da amortização da OE"
            label="Cálculo da amortização da OE"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue')
    },

    emits: ['step-observer-calculo-amortizacao'],

    data: () => ({
      itemsValorTaxaMedia: [
        {
          id: 1,
          name: 'Valor de taxa média de depreciação do AIS'
        },
        {
          id: 0,
          name: 'Valor de contabilidade'
        }
      ],
      valorTaxaMediaSelecionado: null
    }),

    methods: {
      exportData() {
        return {
          valorTaxaMediaSelecionado: this.valorTaxaMediaSelecionado
        };
      }
    }
  };
</script>